import * as React from "react";
const SvgCheckbox = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, xmlns: "http://www.w3.org/2000/svg", fill: "#fff", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 2, stroke: "currentColor" }));
export default SvgCheckbox;
